import { CLOUD_PROVIDER } from "@base/common/constants/index.js";
import { FirebaseConfig } from "./firebase.js";
import { SupabaseConfig } from "./supabase.js";

function getRTDBClient(name) {
  switch (name) {
    case CLOUD_PROVIDER.GCP:
      return new FirebaseConfig();

    case CLOUD_PROVIDER.AWS:
      return new SupabaseConfig();

    default:
      return new FirebaseConfig();
  }
}

let config = window.accountDetails.AppConfig | {};

export let rtdbClient = getRTDBClient(config.Category);
